// Service areas. Ontario-focused. Editable.
export const SERVICE_AREAS = {
  province: "Ontario, Canada",
  remote: "Remote across Canada",
  cities: [
    "Ottawa",
    "Gatineau",
    "Toronto",
    "Mississauga",
    "Hamilton",
    "Kingston",
    "London",
    "Sudbury",
    "Thunder Bay",
    "Windsor",
    "Waterloo",
    "Kitchener",
    "Barrie",
    "Brockville",
    "Pembroke",
  ],
  note:
    "Kostaja works with businesses across Ontario and remotely with clients across Canada. Travel for on-site work is quoted per project.",
};
